import React from "react";
import { Link } from "react-router-dom";
import BackArrow from '../../../assets/images/Frame_18177.png';
import Check_icon from '../../../assets/images/Check_icon.png';

const StepTwo = () => {
    return(
        <>
            <div className='flex flex-col lg:flex-row w-full gap-4 px-4 sm:px-8 lg:px-14 pt-4'>
                {/* section 1 */}
                <div className='flex-1 flex items-center'>
                    <Link
                        to="/dashboard"
                        className={`flex items-center w-auto min-w-[6rem] px-4 py-2 sm:py-3 bg-[#0FA968] text-white font-semibold rounded-lg shadow hover:bg-[#138F5E] transition duration-200`}
                        style={{ fontFamily: 'Roboto', fontSize: '18px', fontWeight: '500', lineHeight: '1.3' }}
                    >
                        <img src={BackArrow} alt="Back" className="mr-2 w-5 h-5 sm:w-6 sm:h-6" />
                        Back
                    </Link>
                    <span className='ml-4 text-xl sm:text-2xl lg:text-[28px]' style={{ fontFamily: 'Roboto', fontWeight: '600', lineHeight: '1.2' }}>New Registration</span>
                </div>

                {/* section 2 */}
                <div className='flex-1 flex items-center justify-start lg:justify-center'>
                    <ol className="flex items-center justify-between w-full max-w-md">
                        <li className="relative flex flex-col flex-grow">
                            <div className="flex items-center ml-0 sm:ml-10">
                                <div className="z-10 flex items-center justify-center w-6 h-6 bg-white border border-[#7F56D9] rounded-full">
                                    <span className="flex w-6 h-6 bg-[#7F56D9] rounded-full">
                                        <img src={Check_icon} alt='check'/>
                                    </span>
                                </div>
                                <div className="flex-grow h-0.5 bg-gray-200"></div> {/* Gray line */}
                            </div>
                            <div className="mt-2 sm:mt-3">
                                <h3 className="font-medium text-gray-900 text-sm sm:text-base">Patient Details</h3>
                            </div>
                        </li>

                        <li className="relative flex flex-col flex-grow">
                            <div className="flex items-center">
                                <div className="flex-grow h-0.5 bg-gray-200"></div>
                                <div className="z-10 flex items-center justify-center w-6 h-6 bg-white border border-[#7F56D9] rounded-full">
                                    <span className="flex w-3 h-3 bg-[#7F56D9] rounded-full"></span>
                                </div>
                                <div className="flex-grow h-0.5 bg-gray-200" style={{ paddingRight: "40px" }}></div> {/* Gray line */}
                            </div>
                            <div className="mt-2 sm:mt-3">
                                <h3 className="font-medium text-gray-900 text-sm sm:text-base">Book Consultation</h3>
                            </div>
                        </li>
                    </ol>
                </div>

                {/* section 3 */}
                <div className='hidden lg:block flex-1'></div>
            </div>

            <hr className="mt-4 mx-4 sm:mx-8 lg:mx-14 border-t-1 border-gray-300" />
        </>
    )
}

export default StepTwo;
